import cn from 'classnames';
import Link from 'next/link';
import React from 'react';
import slugify from 'react-slugify';

import Image from '@/app/_components/Image';
import { assetsUri } from '@/services/api.service';
import { SpecialsReq } from '@/types/request/request.types';
import { directusImageLoader } from '@/utils/loaders';

import styles from './deal-item.module.scss';

export const DealItem: React.FC<{
  dealInfo: SpecialsReq;
  priceCrush?: boolean;
  extraClass?: string;
  category?: string;
}> = ({ dealInfo, extraClass }) => {
  const backgroundUri = `${assetsUri}/${dealInfo?.image}?key=image-390-442`;

  const dealItemContent = (
    <div className={cn(styles.dealItemWrapper)}>
      <Image
        className={styles.dealImage}
        src={backgroundUri}
        loader={directusImageLoader}
        alt={dealInfo.title}
        title={dealInfo.title}
        layout="fill"
        loading="lazy"
      />
      {/* <div className={styles.specialInfo}>
        <h2 className={styles.modelName}>{dealInfo.title}</h2>
        <h2 className={styles.subHeading}>{dealInfo.sub_title}</h2>
        {dealInfo.discount_value && (
          <p className={styles.modelPriceInfo}>
            Save up to{' '}
            <PriceFormat value={dealInfo.discount_value} prefix="R" />
          </p>
        )} */}
        {/*{dealInfo.monthlyRepayment && (*/}
        {/*  <p className={styles.modelPriceInfo}>*/}
        {/*    <PriceFormat*/}
        {/*      value={dealInfo.monthlyRepayment}*/}
        {/*      prefix="R"*/}
        {/*      suffix="pm"*/}
        {/*    />*/}
        {/*  </p>*/}
        {/*)}*/}
        {/* <div className={styles.paymentsInfo}>
          <p>{dealInfo.short_description}</p>
        </div>
      </div> */}
    </div>
  );

  const cmsModelSlug = dealInfo.cms_new_cars?.find(
    (car) => car?.cms_new_cars_id?.slug,
  )?.cms_new_cars_id?.slug;

  const modelSlug =
    cmsModelSlug ||
    (dealInfo.range?.name ? slugify(dealInfo.range.name) : null);

  const promotionUrl = modelSlug
    ? `/promotions/${modelSlug}/${dealInfo.id}`
    : `/promotions/${dealInfo.id}`;

  return (
    <div
      className={cn({
        [styles[extraClass || ''] as string]: extraClass,
      })}
    >
      <Link
        href={promotionUrl}
        key={dealInfo.id}
        passHref
        className={styles.priceCrushWrapper}
        prefetch={false}
      >
        {dealItemContent}
      </Link>
    </div>
  );
};
